import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";
import { Trophy, ArrowRight, Sparkles } from "lucide-react";
import { api } from "../lib/api";

export default function Register() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const nav = useNavigate();

  // Iter 71.8b — track signup funnel
  useEffect(() => {
    api.post("/analytics/track", { event: "signup_start", path: "/register", referrer: document.referrer || "" }).catch(() => {});
  }, []);

  async function onSubmit(e) {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password minimo 6 caratteri"); return; }
    setLoading(true);
    const r = await register(email, password, name);
    setLoading(false);
    if (r.ok) { toast.success("🎉 Benvenuto in Fanta Business!"); nav("/dashboard"); }
    else toast.error(r.error || "Errore");
  }

  function loginGoogle() {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  }

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 relative overflow-hidden flex items-center justify-center p-6">
      <div className="fixed inset-0 pointer-events-none -z-10">
        <div className="absolute top-0 -left-20 w-[500px] h-[500px] bg-emerald-500/15 rounded-full blur-3xl"/>
        <div className="absolute bottom-0 -right-20 w-[500px] h-[500px] bg-amber-500/15 rounded-full blur-3xl"/>
      </div>

      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-3 mb-10" data-testid="register-logo">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center shadow-lg shadow-amber-500/30">
            <Trophy size={20} className="text-slate-900"/>
          </div>
          <div>
            <div className="font-black uppercase tracking-wider text-lg leading-none">Fanta Business</div>
            <div className="text-[10px] tracking-[0.3em] text-amber-400/80 uppercase mt-0.5">ERP fantasy manager</div>
          </div>
        </Link>

        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-emerald-500/40 bg-emerald-500/10 text-emerald-300 text-xs font-bold tracking-widest uppercase mb-4">
          <Sparkles size={12}/> Registrazione
        </div>
        <h1 className="text-4xl sm:text-5xl font-black tracking-tight mb-8" data-testid="register-title">Crea il tuo account 🚀</h1>

        <button onClick={loginGoogle} type="button" data-testid="register-google-btn"
          className="w-full inline-flex items-center justify-center gap-3 px-4 py-3 rounded-md border border-slate-700 hover:border-amber-500 hover:bg-amber-500/5 transition-colors font-bold uppercase tracking-wider text-sm mb-6">
          <svg viewBox="0 0 24 24" width="18" height="18"><path fill="#EA4335" d="M12 5c1.62 0 3.06.55 4.21 1.64l3.15-3.15C17.45 1.83 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5 12 5z"/><path fill="#4285F4" d="M23 12.23c0-.86-.08-1.69-.22-2.5H12v4.73h6.19c-.27 1.44-1.08 2.66-2.29 3.48l3.55 2.75C21.4 18.63 23 15.7 23 12.23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09L2.18 7.07C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.55-2.75c-.98.66-2.23 1.06-3.73 1.06-2.86 0-5.29-2.31-6.16-5.4L2.18 16.09C3.99 19.7 7.7 22.15 12 23z"/></svg>
          Registrati con Google
        </button>

        <div className="flex items-center gap-3 mb-6">
          <div className="flex-1 h-px bg-slate-800"/>
          <span className="text-[10px] text-slate-500 uppercase tracking-widest font-bold">oppure</span>
          <div className="flex-1 h-px bg-slate-800"/>
        </div>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="text-xs tracking-widest text-slate-400 uppercase font-bold block mb-2">👤 Nome</label>
            <input data-testid="register-name"
              className="w-full bg-slate-900 border border-slate-700 rounded-md px-4 py-3 focus:border-amber-500 focus:outline-none focus:ring-1 focus:ring-amber-500 transition-colors"
              required value={name} onChange={(e) => setName(e.target.value)} placeholder="Mister X"/>
          </div>
          <div>
            <label className="text-xs tracking-widest text-slate-400 uppercase font-bold block mb-2">📧 Email</label>
            <input data-testid="register-email"
              className="w-full bg-slate-900 border border-slate-700 rounded-md px-4 py-3 focus:border-amber-500 focus:outline-none focus:ring-1 focus:ring-amber-500 transition-colors"
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@email.it"/>
          </div>
          <div>
            <label className="text-xs tracking-widest text-slate-400 uppercase font-bold block mb-2">🔒 Password</label>
            <input data-testid="register-password"
              className="w-full bg-slate-900 border border-slate-700 rounded-md px-4 py-3 focus:border-amber-500 focus:outline-none focus:ring-1 focus:ring-amber-500 transition-colors"
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="min 6 caratteri"/>
          </div>
          <button type="submit" disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-amber-400 hover:bg-amber-300 text-slate-950 font-bold uppercase tracking-wider disabled:opacity-50 shadow-lg shadow-amber-500/20 transition-all hover:-translate-y-0.5"
            data-testid="register-submit-btn">
            {loading ? "Caricamento…" : "🎉 Crea account"} <ArrowRight size={16}/>
          </button>
        </form>
        <p className="mt-6 text-center text-slate-500 text-sm">
          Già registrato? <Link to="/login" className="text-amber-400 hover:text-amber-300 font-bold" data-testid="register-go-login">Accedi</Link>
        </p>
      </div>
    </div>
  );
}
